import { render, staticRenderFns } from "./GinUpdatedetail.vue?vue&type=template&id=cd53554a&scoped=true"
import script from "./GinUpdatedetail.vue?vue&type=script&lang=js"
export * from "./GinUpdatedetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53554a",
  null
  
)

export default component.exports